<div class="grid w-full">
    
            <div class="grid">
                <!-- Online Store Payment Status -->
                <div class="col-12">
                    <div class="p-3 border-round bg-white border-1 border-200">
                        <div class="flex align-items-center justify-content-between mb-3">
                            <h5 class="m-0 text-primary">Payments</h5>
                            
                            <p-tag severity="warning" value="Please wait..." *ngIf="fetchingStripeStatus"></p-tag>
                            <p-tag severity="warning" value="{{stripAccountStatus}}" *ngIf="!isStripeConnected && !fetchingStripeStatus"></p-tag>
                            <p-tag severity="success" value="{{stripAccountStatus}}" *ngIf="isStripeConnected && !fetchingStripeStatus"></p-tag>
                        </div>
                        
                        <div class="flex flex-column">
                            <!-- Step 1 -->
                            <div>
                               
                                <p class="text-600 ">
                                    Stripe is our secure payment partner for online transactions. Connecting your account enables you to accept credit cards, debit cards, and digital payments.
                                </p>
                                <!-- Next Action for Step 1 -->
                                <div  *ngIf="!isStripeConnected">
                                    <div class="flex align-items-center gap-2 mb-2">
                                        <i class="pi pi-arrow-right text-primary"></i>
                                        <span class="font-medium text-primary">Connect your Stripe account to get started</span>
                                    </div>
                                    <button
                                        pButton
                                        type="button"
                                        
                                        [ngClass]="{'disabled':isConnectStripeAccountLoading || fetchingStripeStatus ||isStripeConnected}"
                                        class="p-button p-button-success p-button-sm"
                                        (click)="openConnectStripeAccount()">
                                         <span *ngIf="isConnectStripeAccountLoading">Please wait...</span>
                                         <span *ngIf="!isConnectStripeAccountLoading">Connect Stripe Account</span>
                                       
                                    </button>
                                    
                                      <div *ngIf="isConnectStripeAccountError && isConnectStripeAccountErrorText != ''">
                                        {{isConnectStripeAccountErrorText}}

                                      </div>
                                    <!-- <a
                                        href="https://connect.stripe.com/oauth/authorize?redirect_uri=https://connect.stripe.com/hosted/oauth&client_id=ca_RxXelYDGGeWumLXp9Uj5Oyw8dP8gs9YV&state=onbrd_SjWaBkI6rELXvmMJ4iULBTOxIj&response_type=code&scope=read_write&stripe_user[country]=US"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        class="p-button p-button-success p-button-sm"
                                    >
                                        <i class="pi pi-link mr-2"></i> Connect Stripe Account
                                    </a> -->
                                </div>
                            </div>
                            
                           
                                
                                <!-- Completion Message -->
                                <div class="ml-6" *ngIf="isOnlineStoreSetup">
                                    <div class="flex align-items-center gap-2">
                                        <i class="pi pi-check text-green-500"></i>
                                        <span class="font-medium text-green-600">All set! Online payments are ready</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                
               
  

